import { ComponentDimensionOptions } from '../types';

export const blankComponenetDimensionOptionsCfn = (): ComponentDimensionOptions => {
	return {
		inside: {
			vertical: {
				// when set, renders ouside of cutout
				// - value renders to the left, + renders to the right
				offset: 0,
				ignore: false,
				render: true
			},
			horizontal: {
				// when set, renders ouside of cutout
				// - value renders above, + renders below
				offset: 0,
				ignore: false,
				render: true
			}
		},
		outside: {
			vertical: {
				ignore: false,
				render: true
			},
			horizontal: {
				ignore: false,
				render: true
			}
		}
	}
};
